import { apiConstants } from '../../apiConstant'
import { serviceCall, serviceCallAuth } from '../../serviceCall'

export const getCallRecordingsApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCallAuth({
      url: apiConstants.VIDEO.GET_CALL_RECORDINGS,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
